import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl} from '../Univ.js'
function IndentEqpList() {
    const [pharmviewData, setpharmviewData] = useState([]);
    useEffect(() => {
        fetchpharmviewData();
    }, []);
    function fetchpharmviewData() {
        axios.get(`${baseUrl}eqp-raise-indent/`)
            .then(response => {
                setpharmviewData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {field: 'id', headerName: 'ID', width: 50},
        {
            field: 'dept',
            headerName: 'Raised to',
            width: 100,
            renderCell: (params) => {
                return params.row.dept.department;
            }
        },
        {
            field: 'user',
            headerName: 'User',
            width: 80,
        },
        {
            field: 'product',
            headerName: 'Product',
            width: 220,
            renderCell: (params) => {
                return params.row.product.product;
            }
        },
        {
            field: 'hsn',
            headerName: 'HSN',
            width: 100,
            renderCell: (params) => {
                return params.row.product.hsn;
            }
        },
        {
            field: 'batch',
            headerName: 'Batch',
            width: 120,
            renderCell: (params) => {
                return params.row.product.batch;
            }
        },
        {
            field: 'pack',
            headerName: 'Pack',
            width: 30,
            renderCell: (params) => {
                return params.row.product.pack;
            }
        },
        {
            field: 'qty',
            headerName: 'Raised Qty',
            width: 90,
        },
        {
            field: 'expiry',
            headerName: 'Expiry',
            width: 120,
            renderCell: (params) => {
                return params.row.product.expiry;
            }
        },
        {
            field: 'mrp',
            headerName: 'MRP',
            width: 80,
            renderCell: (params) => {
                return params.row.product.mrp;
            }
        },
        {
            field: 'issue_qty',
            headerName: 'Action',
            renderCell: (params) => {
                if (params.row.issued_qty == null) {
                    return (
                        <Link target="_blank" to={`/issue-indent-eqp/${params.row.id}/`} className="btn btn-warning">
                            Allocate
                        </Link>
                    );
                } else {
                    return `Issued Qty: ${params.row.issued_qty}`;
                }
            },
            width: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
        {
            field: 'action', headerName: 'Edit',
            renderCell: (params) => (
                <Link target="_blank" to={`/edit-indent-eqp/${params.row.id}/`} className="btn btn-danger">
                    Edit
                </Link>
            ),
            width: 80,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    Indent Equipment List
                </h3>
                {pharmviewData.length > 0 ? (
                    <div style={{height: '100%', width: '100%'}} className="mt-4">
                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={pharmviewData}
                            columns={columns}
                            pageSize={10}
                            slots={{toolbar: GridToolbar}}
                            autoHeight
                        />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </section>
    )
}
export default IndentEqpList;
